<div class="customer-support">
    <div class="row">
        <div class="offset-xl-2 offset-lg-1 offset-md-1 offset-sm-0 col-lg-6 col-xl-6 col-md-5 col-sm-6 col-xs-6">
            <header class="header1">Contact us</header>
            <p>Your AITA team is here to help. Please email us at <span [innerHTML]="email"></span> or call 1-877-ETHICON. Thank you.</p>
        </div>
    </div>
</div>
